<template>
  <div class="ai-seo-page">
    <CRow>
      <CCol col="12" lg="5">
        <CCard>
          <CCardHeader><strong>تنظیمات سئوی خودکار با هوش مصنوعی</strong></CCardHeader>
          <CCardBody>
            <CSelect label="مدل هوش مصنوعی" :options="models" :value.sync="settings.model"/>
            <CInput v-if="settings.model === 'custom'" v-model="settings.custom_model" dir="ltr" label="نام مدل دلخواه"/>
            <CInput v-model="settings.token" type="password" dir="ltr" label="توکن API چت‌جی‌پی‌تی (ChatGPT)" placeholder="sk-..."/>
            <CInput v-model="settings.base_url" dir="ltr" label="آدرس API" description="پیش‌فرض OpenAI است؛ برای سرویس‌های سازگار (مثل AvalAI) آدرس آن را بگذارید."/>
            <CInput v-model="settings.daily_count" type="number" label="تعداد محصول برای سئو در هر روز"/>
            <div class="ai-switch">
              <CSwitch color="success" shape="pill" :checked.sync="settings.enabled"/>
              <label>اجرای خودکار روزانه</label>
            </div>
            <div class="ai-switch">
              <CSwitch color="warning" shape="pill" :checked.sync="settings.rewrite_description"/>
              <label>بازنویسی توضیحات کامل محصول هم انجام شود</label>
            </div>
            <small class="text-muted d-block mb-3">
              فقط عنوان سئو، توضیح متا و کلمهٔ کلیدی تغییر می‌کند، مگر اینکه بازنویسی توضیحات را روشن کنید.
              اجرای روزانه وقتی انجام می‌شود که این صفحه در پنل باز باشد (اولین بار در هر روز، و هر ساعت یک بار بررسی می‌شود).
              توکن فقط در همین مرورگر ذخیره می‌شود.
            </small>
            <CButton color="primary" class="mr-1" @click="save_settings()">ذخیرهٔ تنظیمات</CButton>
            <CButton color="success" class="mr-1" :disabled="running" @click="run_now()">اجرای الان</CButton>
            <CButton color="danger" v-if="running" @click="stop = true">توقف</CButton>
            <div class="mt-2 text-muted" v-if="running">در حال سئو: {{ done }} از {{ total }}</div>
            <div class="mt-2 text-muted" v-if="settings.last_run">آخرین اجرا: {{ settings.last_run }}</div>
          </CCardBody>
        </CCard>
      </CCol>

      <CCol col="12" lg="7">
        <CCard>
          <CCardHeader><strong>تاریخچهٔ اجراها</strong></CCardHeader>
          <CCardBody>
            <div v-if="!history.length" class="text-muted">هنوز اجرایی انجام نشده است.</div>
            <div v-for="run in history" :key="run.id" class="ai-run">
              <div class="ai-run__head">
                <strong>{{ run.date }}</strong>
                <span class="text-muted"> - {{ run.items.filter(x => x.ok).length }} موفق از {{ run.items.length }}</span>
              </div>
              <div v-for="(it, k) in run.items" :key="run.id + '-' + k" class="ai-run__item">
                <span :class="it.ok ? 'text-success' : 'text-danger'">{{ it.ok ? '✓' : '✗' }}</span>
                <a v-if="it.link" :href="it.link" target="_blank">{{ it.name }}</a>
                <span v-else>{{ it.name }}</span>
                <router-link v-if="it.id" :to="'/dashboard/products/edit/' + it.id" class="ai-run__edit">ویرایش</router-link>
                <div class="ai-run__seo" v-if="it.ok">
                  <div><b>عنوان سئو:</b> {{ it.seo_title }}</div>
                  <div><b>توضیح متا:</b> {{ it.meta_desc }}</div>
                  <div><b>کلمهٔ کلیدی:</b> {{ it.keyword }}</div>
                </div>
                <div class="text-danger" v-else>{{ it.error }}</div>
              </div>
            </div>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import axios from "axios";

const SETTINGS_KEY = 'ai_seo_settings';
const HISTORY_KEY = 'ai_seo_history';

export default {
  name: 'AiSeo',
  data() {
    return {
      models: [
        {label: 'GPT-4o', value: 'gpt-4o'},
        {label: 'GPT-4o mini', value: 'gpt-4o-mini'},
        {label: 'GPT-4.1', value: 'gpt-4.1'},
        {label: 'GPT-4.1 mini', value: 'gpt-4.1-mini'},
        {label: 'مدل دلخواه', value: 'custom'},
      ],
      settings: {
        model: 'gpt-4o',
        custom_model: '',
        token: '',
        base_url: 'https://api.openai.com/v1',
        daily_count: 5,
        enabled: false,
        rewrite_description: false,
        last_run: '',
        last_run_day: '',
      },
      history: [],
      running: false,
      stop: false,
      done: 0,
      total: 0,
      timer: null,
    }
  },
  mounted() {
    try { Object.assign(this.settings, JSON.parse(localStorage.getItem(SETTINGS_KEY) || '{}')); } catch (e) {}
    try { this.history = JSON.parse(localStorage.getItem(HISTORY_KEY) || '[]'); } catch (e) { this.history = []; }
    this.check_daily();
    this.timer = setInterval(() => this.check_daily(), 60 * 60 * 1000);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    today() {
      const d = new Date();
      return d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate();
    },
    now_label() {
      try { return new Date().toLocaleString('fa-IR'); } catch (e) { return new Date().toString(); }
    },
    save_settings() {
      this.save_settings_silent();
      alert('تنظیمات ذخیره شد');
    },
    save_settings_silent() {
      localStorage.setItem(SETTINGS_KEY, JSON.stringify(this.settings));
    },
    save_history() {
      localStorage.setItem(HISTORY_KEY, JSON.stringify(this.history.slice(0, 60)));
    },
    check_daily() {
      if (this.settings.enabled && !this.running && this.settings.token && this.settings.last_run_day !== this.today()) {
        this.run_now();
      }
    },
    model_name() {
      return this.settings.model === 'custom' ? this.settings.custom_model : this.settings.model;
    },
    done_ids() {
      const ids = {};
      this.history.forEach((r) => r.items.forEach((it) => { if (it.ok) ids[it.id] = true; }));
      return ids;
    },
    post(url, fields) {
      const fd = new FormData();
      Object.keys(fields || {}).forEach((k) => fd.append(k, fields[k]));
      return axios.post(url, fd, {show_pros: false}).then((r) => r.data);
    },
    editor_to_text(json) {
      try {
        const o = typeof json === 'string' ? JSON.parse(json) : json;
        return (o.blocks || []).map((b) => {
          if (b.type === 'table') return (b.data.content || []).map((r) => r.join(': ')).join('\n');
          if (b.data && b.data.items) return b.data.items.join('\n');
          return (b.data && b.data.text) || '';
        }).join('\n').replace(/<[^>]*>/g, ' ').slice(0, 4000);
      } catch (e) {
        return String(json || '').replace(/<[^>]*>/g, ' ').slice(0, 4000);
      }
    },
    async ask_ai(product) {
      const base = (this.settings.base_url || 'https://api.openai.com/v1').replace(/\/+$/, '');
      const wantDesc = this.settings.rewrite_description;
      const prompt = [
        'تو متخصص سئوی فروشگاه اینترنتی فارسی هستی. برای محصول زیر سئو بنویس.',
        'فقط یک JSON معتبر برگردان با کلیدهای:',
        'seo_title (عنوان سئو فارسی، 50 تا 60 کاراکتر)، meta_description (توضیح متا فارسی، 120 تا 160 کاراکتر، ترغیب‌کننده)، keyword (کلمهٔ کلیدی اصلی)' +
        (wantDesc ? '، description_html (توضیحات کامل فارسی و یکتا، 250 تا 400 کلمه، با تگ‌های ساده p و h2 و ul/li، بدون ادعای نادرست)' : '') + '.',
        'نام محصول: ' + product.name,
        'کد: ' + product.code,
        'مشخصات و توضیحات فعلی: ' + product.text,
      ].join('\n');
      const res = await fetch(base + '/chat/completions', {
        method: 'POST',
        headers: {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + this.settings.token},
        body: JSON.stringify({
          model: this.model_name(),
          messages: [{role: 'user', content: prompt}],
          response_format: {type: 'json_object'},
          temperature: 0.4,
        }),
      });
      const json = await res.json();
      if (!res.ok) throw new Error((json.error && json.error.message) || ('HTTP ' + res.status));
      const out = JSON.parse(json.choices[0].message.content);
      if (!out.seo_title || !out.meta_description) throw new Error('پاسخ مدل ناقص بود');
      return out;
    },
    // Rebuilds exactly what the edit-product page sends, so nothing else on the product changes
    async build_update(product_id, seo) {
      const info = await this.post('/api/admin/product/get_product_info', {product_id: product_id});
      const post = info.post;
      const langs = (await this.post('/api/admin/site/get_languages', {})).data || [];
      let property_group_items = [];
      if (info.property_id && info.property_id != 0) {
        const g = await this.post('/api/admin/product/get_property_groups_with_items', {property_id: info.property_id});
        if (g.error == 0) {
          property_group_items = g.tags;
          property_group_items.forEach((val) => {
            val.items_lang = [];
            val.items.forEach((it) => {
              it.lang_values = langs.map((lng) => {
                let v = '';
                (post.properties || []).forEach((pv) => {
                  if (pv.property_key_id == it.id && pv.lng == lng.id) v = pv.title;
                });
                return {value: v, lng: lng};
              });
            });
          });
        }
      }
      const fd = new FormData();
      fd.append('product_id', product_id);
      (post.gallery || []).forEach((g) => fd.append('post_images[]', g.image_id));
      fd.append('property_group_items', JSON.stringify(property_group_items));
      fd.append('product_type', post.type);
      fd.append('cat_list', (post.categories || []).map((c) => c.category_id));
      fd.append('tags', (post.tags || []).map((t) => t.tag.title.title));
      fd.append('brand_id', post.brand ? post.brand.brand_id : null);
      fd.append('label_id', post.label ? post.label.label_id : null);
      fd.append('name', post.title.title);
      fd.append('url', post.title.slug);
      fd.append('code', post.code);
      fd.append('text', JSON.stringify(post.title.short_description));
      let full = post.title.description;
      if (seo.description_html) {
        full = {time: Date.now(), blocks: [{id: 'aiSeo' + product_id, type: 'paragraph', data: {text: seo.description_html, alignment: 'right'}}], version: '2.28.2'};
      }
      fd.append('full_text', JSON.stringify(full));
      fd.append('meta_desc', seo.meta_description || post.title.meta_description || '');
      fd.append('meta_title', seo.seo_title || post.title.seo_title || '');
      fd.append('keyword', seo.keyword || post.title.keyword || '');
      const pn = post.price_no || {};
      fd.append('price', pn.price !== undefined ? pn.price : '');
      fd.append('product_stock', pn.stock !== undefined ? pn.stock : '');
      fd.append('order_point', pn.order_point !== undefined ? pn.order_point : 0);
      fd.append('product_off_price', pn.off_price !== undefined ? pn.off_price : '');
      fd.append('product_off_price_date', pn.off_expire !== undefined ? pn.off_expire : '');
      fd.append('selected_currency', pn.currency_id !== undefined ? pn.currency_id : 0);
      return {
        fd: fd, slug: post.title.slug, name: post.title.title, code: post.code,
        text: this.editor_to_text(post.title.short_description) + '\n' + this.editor_to_text(post.title.description),
      };
    },
    async run_now() {
      if (!this.settings.token) { alert('توکن API را وارد کنید'); return; }
      if (this.running) return;
      this.save_settings_silent();
      this.running = true;
      this.stop = false;
      this.done = 0;
      const run = {id: Date.now(), date: this.now_label(), items: []};
      this.history.unshift(run);
      try {
        const list = await this.post('/api/admin/product/get_products', {});
        const done = this.done_ids();
        const count = Math.max(1, parseInt(this.settings.daily_count) || 1);
        const todo = (list.items || []).filter((p) => p.status == 1 && !done[p.id]).slice(0, count);
        this.total = todo.length;
        const site = (localStorage.getItem('site_url') || '').replace(/\/+$/, '');
        for (let i = 0; i < todo.length; i++) {
          if (this.stop) break;
          const p = todo[i];
          const entry = {id: p.id, name: (p.title && p.title.title) || p.name, ok: false, link: ''};
          try {
            const current = await this.build_update(p.id, {});
            const seo = await this.ask_ai({name: current.name, code: current.code, text: current.text});
            const upd = await this.build_update(p.id, seo);
            const r = await axios.post('/api/admin/product/update_product', upd.fd, {show_pros: false});
            if (r.data && r.data.error == 0) {
              entry.ok = true;
              entry.link = site ? site + '/product/' + upd.slug : '';
              entry.seo_title = seo.seo_title;
              entry.meta_desc = seo.meta_description;
              entry.keyword = seo.keyword;
            } else {
              entry.error = (r.data && (r.data.msg || r.data.message)) || 'خطا در ذخیره';
            }
          } catch (e) {
            entry.error = e && e.message ? e.message : String(e);
          }
          run.items.push(entry);
          this.done = i + 1;
          this.save_history();
        }
      } catch (e) {
        run.items.push({id: 0, name: 'خطا در دریافت لیست محصولات', ok: false, error: e && e.message ? e.message : String(e)});
      }
      this.settings.last_run = this.now_label();
      this.settings.last_run_day = this.today();
      this.save_settings_silent();
      this.save_history();
      this.running = false;
    },
  }
}
</script>

<style scoped>
.ai-switch { display: flex; align-items: center; gap: 10px; margin-bottom: 12px; }
.ai-switch label { margin: 0; }
.ai-run { border: 1px solid rgba(128,148,174,.2); border-radius: 12px; padding: 12px; margin-bottom: 12px; }
.ai-run__head { margin-bottom: 8px; }
.ai-run__item { padding: 8px 0; border-top: 1px dashed rgba(128,148,174,.25); font-size: 13px; }
.ai-run__edit { margin-right: 8px; font-size: 12px; }
.ai-run__seo { color: #6e82a5; font-size: 12px; margin-top: 4px; }
</style>
